import { Alert } from '@mui/material'

const itemStyle: any = {
  breakInside: 'avoid',
  maxWidth: '100%',
  margin: '0.5rem',
}

export function DisplayValue({ value }: { value: TODO }) {
  //handle empty
  const emptyArray = Array.isArray(value) && value.length === 0
  const emptyString = value === ''

  if (emptyArray || emptyString || value === null || value === undefined) {
    return <Alert severity="warning">Empty: Field will be cleared.</Alert>
  }

  //handle data types
  if (typeof value === 'string' || typeof value === 'number') {
    return value
  }

  if (Array.isArray(value)) {
    if (value[0].description) {
      return value.map((v) => (
        <div style={itemStyle} key={v.code}>
          {v?.description}{' '}
        </div>
      ))
    } else {
      return value.map((v) => <div style={itemStyle}>{v}</div>)
    }
  }

  if (value.description) return value?.description as string

  // return value;
  return 'Empty'
}
